import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useState } from "react";

export default function CommonDateTimePicker({
  className,
  value,
  format,
  name,
  style,
  handleChange,
  minDate,
  disabled,
  minDateTime,
  views,
  placeholder,
}) {
  const CalendarIcon = () => (
    <i className="ri-calendar-2-line" style={{ fontSize: "1.2rem" }}></i>
  );
  const [open, setOpen] = useState(false);
  const isError = className?.includes("error-input");
  const dateFormat = localStorage.getItem("dateFormat") || "DD MMM YYYY";
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DateTimePicker
        name={name}
        className={className}
        disabled={disabled}
        views={views}
        onChange={handleChange}
        value={value}
        format={format ? format : dateFormat}
        minDateTime={minDateTime}
        minDate={minDate}
        closeOnSelect={false}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        slots={{
          openPickerIcon: CalendarIcon,
        }}
        slotProps={{
          textField: {
            onClick: () => setOpen(true),
            placeholder: placeholder ? placeholder : '',
            size: "small",
            InputProps: {
              sx: {
                ...style,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: isError ? "#f06548" : "#d3d3d3", // 👈 default state
                  borderWidth: isError ? "0px" : "1px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: isError ? "#f06548" : "#d3d3d3",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: isError ? "#f06548" : "#d3d3d3",
                  borderWidth: isError ? "0px" : "1px",
                },
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}
